import { render, staticRenderFns } from "./Transformer.vue?vue&type=template&id=4c644098&scoped=true&"
import script from "./Transformer.vue?vue&type=script&lang=js&"
export * from "./Transformer.vue?vue&type=script&lang=js&"
import style0 from "./Transformer.vue?vue&type=style&index=0&id=4c644098&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c644098",
  null
  
)

export default component.exports